import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';
import { Flags, getDefaultFlags, getStoredFlagOverrides } from 'utils/flags';

export const flagsSliceName = 'flags';

export const getInitialState = () => ({
  queryParamOverrides: {} as Record<string, boolean>,
  flags: { ...getDefaultFlags(), ...getStoredFlagOverrides() },
});

export const flagsSlice = createSlice({
  name: flagsSliceName,
  initialState: getInitialState(),
  reducers: {
    setQueryParamOverrides(state, { payload }: PayloadAction<Record<string, boolean>>) {
      state.queryParamOverrides = { ...payload };
    },
    updateFlags(state, { payload }: PayloadAction<Record<keyof Flags, boolean>>) {
      state.flags = {
        ...state.flags,
        ...payload,
      };
    },
    reset(state) {
      // purposefully skip queryParamOverrides
      const { queryParamOverrides, ...rest } = getInitialState();
      Object.assign(state, rest);
    },
  },
});

export default flagsSlice.reducer;
export const { updateFlags, setQueryParamOverrides, reset } = flagsSlice.actions;

export const selectFlags = (state: RootState) => {
  return state[flagsSliceName].flags;
};

export const selectQueryParamOverrides = (state: RootState) => {
  return state[flagsSliceName].queryParamOverrides;
};
